import {
	InstrumentsCustomizationControllerV3ApiFactory,
	type ListInstrumentsRequest,
	type UserInstrumentClassificationDto,
	type UserInstrumentDto,
} from "@eu.mdotm.api/sphere";
import { getApiGen } from "$root/api/factory";
import { axiosExtract } from "$root/third-party-integrations/axios";
import type { PaginationResponse } from "@mdotm/shadcn/legacy/components";
import type { ColDef } from "ag-grid-community";
import type { PaginatedUserInstrumentsRequestProps } from "./types";

export function enabledClassificationUuids(
	columnsMetadata: UserInstrumentClassificationDto[],
	columns: ColDef<UserInstrumentDto>[],
) {
	return columnsMetadata
		.filter((metadata) => {
			const matchedColumn = columns.find((x) => x.colId === metadata.classificationUuid);
			return matchedColumn != null && metadata.fieldType != null && !matchedColumn.hide;
		})
		.map((metadata) => metadata.classificationUuid)
		.filter((c) => c != null);
}
export function createListInstrumentsRequest(params: PaginatedUserInstrumentsRequestProps): ListInstrumentsRequest {
	return {
		offset: params.skip,
		limit: params.take,
		fields: params.filters?.fields,
		keyword: params.filters?.query,
		...(params.orderBy?.length
			? {
					sortBy: [params.orderBy.at(0)!.columnName],
					sortDirection: params.orderBy.at(0)?.direction === "asc" ? "ASC" : "DESC",
				}
			: {}),
		selectableBaskets: params.filters?.selectedBaskets ?? [],
		tagValue: params.filters?.tags,
	};
}

export async function getPaginatedUserInstruments(
	params: PaginatedUserInstrumentsRequestProps,
): Promise<PaginationResponse<UserInstrumentDto>> {
	const instrumentCustomizationV3Api = getApiGen(InstrumentsCustomizationControllerV3ApiFactory);
	const paginationResult = await axiosExtract(
		instrumentCustomizationV3Api.listInstruments1(createListInstrumentsRequest(params)),
	);

	return {
		items: paginationResult.items ?? [],
		total: paginationResult.pagination?.total ?? 0,
	};
}
